// Normalize only spelling equivalents. Do not broaden a customer's product intent.
window.zepuniSearchQuery = function (value) {
  return String(value || '').trim().replace(/\s+/g, ' ')
    .replace(/\bcaes\b/giu, 'cães')
    .replace(/\bmaquilhajem\b/giu, 'maquilhagem')
    .replace(/\bpinceis\b/giu, 'pincéis');
};
document.addEventListener('submit', function (event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  const input = form.querySelector('input[name="q"]');
  if (input && new URL(form.action, location.href).pathname.endsWith('/search')) {
    input.value = window.zepuniSearchQuery(input.value);
  }
}, true);

class PredictiveSearch extends HTMLElement {
  constructor () {
    super()

    this.form = this.querySelector('form.search-form')
    this.input = this.form?.querySelector('input[type="search"]')
    this.results = this.form?.querySelector('#predictive-search')
    this.status = this.form?.querySelector('#predictive-search-status')
    if (!this.input || !this.results || !this.status) return

    this.emptyContainer = this.querySelector('.search-empty')
    this.cartUpsells = this.querySelector('.cart-upsells')

    this.input.addEventListener('input', window.theme.debounce((event) => {
      this.getSearchResults()
    }, 300).bind(this))

    document.querySelector('#offcanvas-search')?.addEventListener('shown.bs.offcanvas', () => {
      this.input.focus()
    })
    this.accessibilityEventIsInit = false
    this.input.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        this.request?.abort()
        this.sequence = (this.sequence || 0) + 1
        this.results.innerHTML = ''
        this.input.setAttribute('aria-expanded', 'false')
        this.input.removeAttribute('aria-activedescendant')
        this.status.textContent = ''
      }
    })
  }

  showError () {
    const lang = document.documentElement.lang.slice(0, 2)
    const copy = {
      pt: 'As sugestões estão indisponíveis. Prima Enter para pesquisar todos os resultados.',
      en: 'Suggestions are unavailable. Press Enter to search all results.',
      es: 'Las sugerencias no están disponibles. Pulsa Enter para buscar todos los resultados.',
      fr: 'Les suggestions sont indisponibles. Appuyez sur Entrée pour rechercher.',
      de: 'Vorschläge sind nicht verfügbar. Drücke Enter, um zu suchen.',
      it: 'I suggerimenti non sono disponibili. Premi Invio per cercare.'
    }
    this.results.innerHTML = ''
    const message = document.createElement('p')
    message.className = 'zp-search-error'
    message.textContent = copy[lang] || copy.en
    this.results.append(message)
    this.status.textContent = message.textContent
    this.input.setAttribute('aria-expanded', 'false')
    this.input.removeAttribute('aria-activedescendant')
  }

  async getSearchResults () {
    const searchTerm = window.zepuniSearchQuery(this.input.value)
    const sequence = this.sequence = (this.sequence || 0) + 1
    this.request?.abort()
    this.request = new AbortController()

    if (searchTerm.length) {
      let response
      try {
        response = await fetch(`${window.Shopify.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=${encodeURIComponent(this.dataset.resourcesType)}&resources[limit]=10&section_id=predictive-search`, { signal: this.request.signal })
      } catch (error) {
        if (error.name !== 'AbortError' && sequence === this.sequence) this.showError()
        return
      }
      if (sequence !== this.sequence) return

      if (response.ok) {
        const data = await response.text()
        if (sequence !== this.sequence) return
        const resultSection = new DOMParser().parseFromString(data, 'text/html').querySelector('#shopify-section-predictive-search')
        if (!resultSection) { this.showError(); return }
        const resultsMarkup = resultSection.innerHTML

        this.results.innerHTML = resultsMarkup

        this.emptyContainer?.setAttribute('hidden', 'hidden')
        this.cartUpsells?.setAttribute('hidden', 'hidden')
        this.input.setAttribute('aria-expanded', 'true')
        this.status.textContent = this.querySelector('#predictive-search-results')?.dataset.resultsText || ''

        this.results.querySelectorAll('.jdgm-prev-badge__stars').forEach(elem => {
          elem.setAttribute('tabindex', '-1')
        })
        this.handleAccessibility()
      } else {
        this.showError()
      }
    } else {
      this.emptyContainer?.removeAttribute('hidden')
      this.cartUpsells?.removeAttribute('hidden')
      this.results.innerHTML = ''
      this.input.setAttribute('aria-expanded', 'false')
      this.input.removeAttribute('aria-activedescendant')
      this.status.textContent = ''
    }
  }

  handleAccessibility () {
    let x = -1

    function listenKeyup (event) {
      const items = this.querySelectorAll('#predictive-search-results a, #predictive-search-results button')

      if (!items.length) return

      if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
        items.forEach(elem => {
          elem.closest('[role="option"]')?.setAttribute('aria-selected', 'false')
        })
      }

      switch (event.code) {
      case 'ArrowUp':
        if (x <= 0) {
          x = items.length
        }
        x--
        items.forEach((elem, index) => {
          if (index === x) {
            elem.focus()
            const option = elem.closest('[role="option"]')
            option?.setAttribute('aria-selected', 'true')
            if (option?.id) this.input.setAttribute('aria-activedescendant', option.id)
          }
        })
        break
      case 'ArrowDown':
        if (x === items.length - 1) {
          x = -1
        }
        x++
        items.forEach((elem, index) => {
          if (index === x) {
            elem.focus()
            const option = elem.closest('[role="option"]')
            option?.setAttribute('aria-selected', 'true')
            if (option?.id) this.input.setAttribute('aria-activedescendant', option.id)
          }
        })
        break
      case 'Enter':
        // Native form submission handles Enter.
        break
      }
    }

    if (!this.accessibilityEventIsInit) {
      this.addEventListener('keyup', listenKeyup)
      this.accessibilityEventIsInit = true
    }
  }
}

if (!customElements.get('predictive-search')) customElements.define('predictive-search', PredictiveSearch)
